import React from 'react';
import PropTypes from 'prop-types';
import styles from './CarRow.scss';

const CarRow = (props) => {
  const { car, configType } = props;

  return (
    <div className={styles.carRow} key={car.id}>
      <div className={styles.carImageContainer}>
        <img alt={car.name} src={car.carImg} />
      </div>
      <div className={styles.carDetails}>
        <ul>
          <li className={styles.carName}>
            <span>{car.name}</span>
          </li>
          <li>
            Condition: <span>{car.condition}</span>
          </li>
          <li>
            VIN: <span>{car.id}</span>
          </li>
          <li>
            Stock#: <span>{car.stock}</span>
          </li>
        </ul>
      </div>
      <div className={styles.carPricing}>
        <div
          className="prodigy-pricing-button-group"
          data-config-type={configType}
          data-vin={car.id}
        ></div>
      </div>
    </div>
  );
};

CarRow.propTypes = {
  car: PropTypes.object,
  configType: PropTypes.string,
};

export default CarRow;
